import { render, staticRenderFns } from "./column-charts.vue?vue&type=template&id=01674b3b&scoped=true"
import script from "./column-charts.vue?vue&type=script&lang=ts"
export * from "./column-charts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01674b3b",
  null
  
)

export default component.exports